import Vue from 'vue';
import { cloneDeep, forEach } from 'lodash';
import SharedMixinMethods from './shared_mixin_methods';

// if a method is missing, please look at either helper_methods.js OR shared_mixin_methods.js first
export default {
  mixins: [SharedMixinMethods],
  data() {
    return {
      originalProperties: {},
    };
  },
  created() {
    this.$eventHub.$on(this.pageComponent.uuid, this.onEventChange);
    this.originalProperties = Object.freeze(cloneDeep(this.pageComponent.properties));
  },
  beforeDestroy() {
    this.$eventHub.$off(this.pageComponent.uuid);
  },
  methods: {
    onEventChange(event) {
      if (this.properties) {
        // console.log(`onEventChange: ${event.type}`, event);
        this.fireEventRecorder(event);
        if (event.type === 'show') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          if (target) target.properties.hidden = false;
        } else if (event.type === 'hide') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          if (target) target.properties.hidden = true;
        } else if (event.type === 'show_modal') {
          this.showModal(event);
        } else if (event.type === 'hide_modal') {
          this.hideModal(event);
        } else if (event.type === 'clear_multiple_choice') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.clearMultipleChoice(target);
        } else if (event.type === 'clear_drag_and_drop') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.clearDragAndDrop(target);
        } else if (event.type === 'show_feedback') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.showFeedback(target);
        } else if (event.type === 'show_answers') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.showAnswers(target);
        } else if (event.type === 'reset_feedback') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.resetFeedback(target);
        } else if (event.type === 'open_keyboard') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.openKeyboard(target, event.keyboard_target);
        } else if (event.type === 'reset_tree_to_default') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          // // reset cards that are flipped over
          // const flipCards = document.getElementsByClassName('card-flip');
          // console.log("flipCards:", flipCards);
          // // loop through all the cards and remove any that have an active class
          // forEach(flipCards, (card) => {
          //   card.classList.remove('active');
          // });
          // // reset any active blur-this containers.
          // const blurThis = document.getElementsByClassName('blur-this');
          // // loop through all the container and remove any that have an active class
          // forEach(blurThis, (container) => {
          //   container.classList.remove('active');
          // });
          this.resetTreeToDefault(target);
        }
      }
    },
    showFeedback() {
      const mc = this;

      if (mc) {
        mc.revealAnswer();
      }
    },
    resetFeedback() {
      // eslint-disable-next-line no-unused-vars
      const mc = this;
    },
    showAnswers() {
      const mc = this;

      if (mc.$children.length > 0) {
        mc.$children[0].checkAnswer();
      }
    },
    clearMultipleChoice(event) {
      if (event.$children.length > 0) {
        event.$children[0].resetMultipleChoice();
      }
    },
    clearDragAndDrop(event) {
      const dnd = event;

      if (dnd) {
        dnd.resetDragAndDrop();
      }
    },
    openKeyboard(event, input) {
      // get uuid of the right keyboard, show it and connect it
      const keyboard = document.getElementById(event.$el.id);
      const inputTarget = input; // input to write too

      if (keyboard && this.$refs[`draggableRoot-${this.pageComponent.uuid}`]) {
        // show keyboard and hook it up
        this.$refs[`draggableRoot-${this.pageComponent.uuid}`].style.display = 'block';
        keyboard.style.display = 'block';
        const target = document.getElementById(inputTarget);
        this.input = target;
      }
    },
    unlockVideoIfPlaying(video) {
      const lock = Vue.prototype.$videoLock;
      if (video && lock) {
        if (video.id === lock.uuid) {
          this.$eventHub.$emit('clear_video_lock');
        }
      }
    },
  },
};
